// source: core.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
const proto = {};

goog.exportSymbol('proto.org.dash.platform.dapi.v0.BlockHeaders', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.FromBlockCase', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.ResponsesCase', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BloomFilter', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockRequest.BlockCase', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Status', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.Status', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetTransactionRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.GetTransactionResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.InstantSendLockMessages', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.MasternodeListRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.MasternodeListResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.RawTransactions', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.FromBlockCase', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse', null, { proto });
goog.exportSymbol('proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.ResponsesCase', null, { proto });
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.displayName = 'proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.displayName = 'proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockRequest.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBlockResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBlockResponse.displayName = 'proto.org.dash.platform.dapi.v0.GetBlockResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.displayName = 'proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.displayName = 'proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.displayName = 'proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.displayName = 'proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetTransactionRequest.displayName = 'proto.org.dash.platform.dapi.v0.GetTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetTransactionResponse.displayName = 'proto.org.dash.platform.dapi.v0.GetTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_);
};
goog.inherits(proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.displayName = 'proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.oneofGroups_);
};
goog.inherits(proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.displayName = 'proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.BlockHeaders = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.dash.platform.dapi.v0.BlockHeaders.repeatedFields_, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.BlockHeaders, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.BlockHeaders.displayName = 'proto.org.dash.platform.dapi.v0.BlockHeaders';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.displayName = 'proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.displayName = 'proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_);
};
goog.inherits(proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.displayName = 'proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.BloomFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.BloomFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.BloomFilter.displayName = 'proto.org.dash.platform.dapi.v0.BloomFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_);
};
goog.inherits(proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.displayName = 'proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.RawTransactions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.dash.platform.dapi.v0.RawTransactions.repeatedFields_, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.RawTransactions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.RawTransactions.displayName = 'proto.org.dash.platform.dapi.v0.RawTransactions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.dash.platform.dapi.v0.InstantSendLockMessages.repeatedFields_, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.InstantSendLockMessages, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.InstantSendLockMessages.displayName = 'proto.org.dash.platform.dapi.v0.InstantSendLockMessages';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.MasternodeListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.MasternodeListRequest.displayName = 'proto.org.dash.platform.dapi.v0.MasternodeListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.dash.platform.dapi.v0.MasternodeListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.dash.platform.dapi.v0.MasternodeListResponse.displayName = 'proto.org.dash.platform.dapi.v0.MasternodeListResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    version: (f = msg.getVersion()) && proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.toObject(includeInstance, f),
    time: (f = msg.getTime()) && proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    syncProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    chain: (f = msg.getChain()) && proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.toObject(includeInstance, f),
    network: (f = msg.getNetwork()) && proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 2:
      var value = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    case 3:
      var value = /** @type {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSyncProgress(value);
      break;
    case 5:
      var value = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.deserializeBinaryFromReader);
      msg.setChain(value);
      break;
    case 7:
      var value = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.deserializeBinaryFromReader);
      msg.setNetwork(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.serializeBinaryToWriter
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSyncProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getChain();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.serializeBinaryToWriter
    );
  }
  f = message.getNetwork();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Status = {
  NOT_STARTED: 0,
  SYNCING: 1,
  READY: 2,
  ERROR: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocol: jspb.Message.getFieldWithDefault(msg, 1, 0),
    software: jspb.Message.getFieldWithDefault(msg, 2, 0),
    agent: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProtocol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSoftware(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProtocol();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSoftware();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getAgent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint32 protocol = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.getProtocol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.setProtocol = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 software = 2;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.getSoftware = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.setSoftware = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string agent = 3;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.getAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version.prototype.setAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.toObject = function(includeInstance, msg) {
  var f, obj = {
    now: jspb.Message.getFieldWithDefault(msg, 1, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 2, 0),
    median: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNow(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMedian(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNow();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMedian();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional uint32 now = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.getNow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.setNow = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 offset = 2;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 median = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.getMedian = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time.prototype.setMedian = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    headersCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    blocksCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    bestBlockHash: msg.getBestBlockHash_asB64(),
    difficulty: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    chainWork: msg.getChainWork_asB64(),
    isSynced: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    syncProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeadersCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBlocksCount(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBestBlockHash(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDifficulty(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChainWork(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSynced(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSyncProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeadersCount();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getBlocksCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getBestBlockHash_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getDifficulty();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getChainWork_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      6,
      f
    );
  }
  f = message.getIsSynced();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getSyncProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 headers_count = 2;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getHeadersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setHeadersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 blocks_count = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getBlocksCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setBlocksCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes best_block_hash = 4;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getBestBlockHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes best_block_hash = 4;
 * This is a type-conversion wrapper around `getBestBlockHash()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getBestBlockHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBestBlockHash()));
};


/**
 * optional bytes best_block_hash = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBestBlockHash()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getBestBlockHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBestBlockHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setBestBlockHash = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional double difficulty = 5;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getDifficulty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setDifficulty = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional bytes chain_work = 6;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getChainWork = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes chain_work = 6;
 * This is a type-conversion wrapper around `getChainWork()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getChainWork_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChainWork()));
};


/**
 * optional bytes chain_work = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChainWork()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getChainWork_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChainWork()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setChainWork = function(value) {
  return jspb.Message.setProto3BytesField(this, 6, value);
};


/**
 * optional bool is_synced = 7;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getIsSynced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setIsSynced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional double sync_progress = 8;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.getSyncProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain.prototype.setSyncProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.toObject = function(includeInstance, msg) {
  var f, obj = {
    relay: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    incremental: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRelay(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setIncremental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRelay();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getIncremental();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double relay = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.prototype.getRelay = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.prototype.setRelay = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double incremental = 2;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.prototype.getIncremental = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.prototype.setIncremental = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.toObject = function(includeInstance, msg) {
  var f, obj = {
    peersCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fee: (f = msg.getFee()) && proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network;
  return proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPeersCount(value);
      break;
    case 2:
      var value = new proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.deserializeBinaryFromReader);
      msg.setFee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeersCount();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFee();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 peers_count = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.getPeersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.setPeersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional NetworkFee fee = 2;
 * @return {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.getFee = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee, 2));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.NetworkFee|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} returns this
*/
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.setFee = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.clearFee = function() {
  return this.setFee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network.prototype.hasFee = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Version version = 1;
 * @return {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.getVersion = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version, 1));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Version|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
*/
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Time time = 2;
 * @return {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.getTime = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time, 2));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Time|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
*/
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.hasTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Status status = 3;
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Status}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.getStatus = function() {
  return /** @type {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Status} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional double sync_progress = 4;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.getSyncProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.setSyncProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional Chain chain = 5;
 * @return {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.getChain = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain, 5));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Chain|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
*/
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.setChain = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.clearChain = function() {
  return this.setChain(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.hasChain = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Network network = 7;
 * @return {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.getNetwork = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network, 7));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.Network|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
*/
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.setNetwork = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.clearNetwork = function() {
  return this.setNetwork(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockchainStatusResponse.prototype.hasNetwork = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest;
  return proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    proTxHash: msg.getProTxHash_asB64(),
    posePenalty: jspb.Message.getFieldWithDefault(msg, 3, 0),
    isSynced: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    syncProgress: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse;
  return proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setProTxHash(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPosePenalty(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsSynced(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSyncProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getProTxHash_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getPosePenalty();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getIsSynced();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getSyncProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.Status = {
  UNKNOWN: 0,
  WAITING_FOR_PROTX: 1,
  POSE_BANNED: 2,
  REMOVED: 3,
  OPERATOR_KEY_CHANGED: 4,
  PROTX_IP_CHANGED: 5,
  READY: 6,
  ERROR: 7
};

/**
 * optional Status status = 1;
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.Status}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getStatus = function() {
  return /** @type {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.Status} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.Status} value
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bytes pro_tx_hash = 2;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getProTxHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes pro_tx_hash = 2;
 * This is a type-conversion wrapper around `getProTxHash()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getProTxHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getProTxHash()));
};


/**
 * optional bytes pro_tx_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getProTxHash()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getProTxHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getProTxHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.setProTxHash = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint32 pose_penalty = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getPosePenalty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.setPosePenalty = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool is_synced = 4;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getIsSynced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.setIsSynced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional double sync_progress = 5;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.getSyncProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetMasternodeStatusResponse.prototype.setSyncProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.BlockCase = {
  BLOCK_NOT_SET: 0,
  HEIGHT: 1,
  HASH: 2
};

/**
 * @return {proto.org.dash.platform.dapi.v0.GetBlockRequest.BlockCase}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.getBlockCase = function() {
  return /** @type {proto.org.dash.platform.dapi.v0.GetBlockRequest.BlockCase} */(jspb.Message.computeOneofCase(this, proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    height: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hash: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockRequest}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockRequest;
  return proto.org.dash.platform.dapi.v0.GetBlockRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockRequest}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeight(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 height = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockRequest} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.setHeight = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockRequest} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.clearHeight = function() {
  return jspb.Message.setOneofField(this, 1, proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string hash = 2;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockRequest} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.setHash = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockRequest} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.clearHash = function() {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.GetBlockRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetBlockRequest.prototype.hasHash = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBlockResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    block: msg.getBlock_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockResponse}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBlockResponse;
  return proto.org.dash.platform.dapi.v0.GetBlockResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockResponse}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBlock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBlockResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBlockResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlock_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes block = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.prototype.getBlock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes block = 1;
 * This is a type-conversion wrapper around `getBlock()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.prototype.getBlock_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBlock()));
};


/**
 * optional bytes block = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBlock()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.prototype.getBlock_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBlock()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBlockResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBlockResponse.prototype.setBlock = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest;
  return proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    height: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse;
  return proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 height = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetBestBlockHeightResponse.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    transaction: msg.getTransaction_asB64(),
    allowHighFees: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    bypassLimits: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest;
  return proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTransaction(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowHighFees(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBypassLimits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransaction_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getAllowHighFees();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getBypassLimits();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional bytes transaction = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.getTransaction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes transaction = 1;
 * This is a type-conversion wrapper around `getTransaction()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.getTransaction_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTransaction()));
};


/**
 * optional bytes transaction = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTransaction()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.getTransaction_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTransaction()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.setTransaction = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bool allow_high_fees = 2;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.getAllowHighFees = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.setAllowHighFees = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool bypass_limits = 3;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.getBypassLimits = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionRequest.prototype.setBypassLimits = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse;
  return proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string transaction_id = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.prototype.getTransactionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.BroadcastTransactionResponse.prototype.setTransactionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionRequest}
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetTransactionRequest;
  return proto.org.dash.platform.dapi.v0.GetTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionRequest}
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionRequest} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    transaction: msg.getTransaction_asB64(),
    blockHash: msg.getBlockHash_asB64(),
    height: jspb.Message.getFieldWithDefault(msg, 3, 0),
    confirmations: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isInstantLocked: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    isChainLocked: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetTransactionResponse;
  return proto.org.dash.platform.dapi.v0.GetTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTransaction(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBlockHash(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConfirmations(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInstantLocked(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsChainLocked(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransaction_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getBlockHash_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getConfirmations();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getIsInstantLocked();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getIsChainLocked();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional bytes transaction = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getTransaction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes transaction = 1;
 * This is a type-conversion wrapper around `getTransaction()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getTransaction_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTransaction()));
};


/**
 * optional bytes transaction = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTransaction()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getTransaction_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTransaction()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.setTransaction = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional bytes block_hash = 2;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getBlockHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes block_hash = 2;
 * This is a type-conversion wrapper around `getBlockHash()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getBlockHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBlockHash()));
};


/**
 * optional bytes block_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBlockHash()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getBlockHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBlockHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.setBlockHash = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional uint32 height = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 confirmations = 4;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getConfirmations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.setConfirmations = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_instant_locked = 5;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getIsInstantLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.setIsInstantLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool is_chain_locked = 6;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.getIsChainLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.GetTransactionResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetTransactionResponse.prototype.setIsChainLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.FromBlockCase = {
  FROM_BLOCK_NOT_SET: 0,
  FROM_BLOCK_HASH: 1,
  FROM_BLOCK_HEIGHT: 2
};

/**
 * @return {proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.FromBlockCase}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.getFromBlockCase = function() {
  return /** @type {proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.FromBlockCase} */(jspb.Message.computeOneofCase(this, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromBlockHash: msg.getFromBlockHash_asB64(),
    fromBlockHeight: jspb.Message.getFieldWithDefault(msg, 2, 0),
    count: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest;
  return proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFromBlockHash(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFromBlockHeight(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional bytes from_block_hash = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.getFromBlockHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes from_block_hash = 1;
 * This is a type-conversion wrapper around `getFromBlockHash()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.getFromBlockHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFromBlockHash()));
};


/**
 * optional bytes from_block_hash = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFromBlockHash()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.getFromBlockHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFromBlockHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.setFromBlockHash = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.clearFromBlockHash = function() {
  return jspb.Message.setOneofField(this, 1, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.hasFromBlockHash = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 from_block_height = 2;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.getFromBlockHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.setFromBlockHeight = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.clearFromBlockHeight = function() {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.hasFromBlockHeight = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 count = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksRequest.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.ResponsesCase = {
  RESPONSES_NOT_SET: 0,
  BLOCK_HEADERS: 1,
  CHAIN_LOCK: 2
};

/**
 * @return {proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.ResponsesCase}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.getResponsesCase = function() {
  return /** @type {proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.ResponsesCase} */(jspb.Message.computeOneofCase(this, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    blockHeaders: (f = msg.getBlockHeaders()) && proto.org.dash.platform.dapi.v0.BlockHeaders.toObject(includeInstance, f),
    chainLock: msg.getChainLock_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse;
  return proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.dash.platform.dapi.v0.BlockHeaders;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.BlockHeaders.deserializeBinaryFromReader);
      msg.setBlockHeaders(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setChainLock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlockHeaders();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.dash.platform.dapi.v0.BlockHeaders.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional BlockHeaders block_headers = 1;
 * @return {?proto.org.dash.platform.dapi.v0.BlockHeaders}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.getBlockHeaders = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.BlockHeaders} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.BlockHeaders, 1));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.BlockHeaders|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} returns this
*/
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.setBlockHeaders = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.clearBlockHeaders = function() {
  return this.setBlockHeaders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.hasBlockHeaders = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes chain_lock = 2;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.getChainLock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes chain_lock = 2;
 * This is a type-conversion wrapper around `getChainLock()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.getChainLock_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getChainLock()));
};


/**
 * optional bytes chain_lock = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChainLock()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.getChainLock_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getChainLock()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.setChainLock = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.clearChainLock = function() {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.BlockHeadersWithChainLocksResponse.prototype.hasChainLock = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.BlockHeaders.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeaders} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.toObject = function(includeInstance, msg) {
  var f, obj = {
    headersList: msg.getHeadersList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeaders}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.BlockHeaders;
  return proto.org.dash.platform.dapi.v0.BlockHeaders.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeaders} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeaders}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addHeaders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.BlockHeaders.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.BlockHeaders} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeadersList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes headers = 1;
 * @return {!Array<string>}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.getHeadersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes headers = 1;
 * This is a type-conversion wrapper around `getHeadersList()`
 * @return {!Array<string>}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.getHeadersList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getHeadersList()));
};


/**
 * repeated bytes headers = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getHeadersList()`
 * @return {!Array<!Uint8Array>}
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.getHeadersList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getHeadersList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeaders} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.setHeadersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeaders} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.addHeaders = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.dash.platform.dapi.v0.BlockHeaders} returns this
 */
proto.org.dash.platform.dapi.v0.BlockHeaders.prototype.clearHeadersList = function() {
  return this.setHeadersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    blocks: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest;
  return proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBlocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlocks();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 blocks = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.prototype.getBlocks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest} returns this
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeRequest.prototype.setBlocks = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    fee: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse;
  return proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFee();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double fee = 1;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse} returns this
 */
proto.org.dash.platform.dapi.v0.GetEstimatedTransactionFeeResponse.prototype.setFee = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.FromBlockCase = {
  FROM_BLOCK_NOT_SET: 0,
  FROM_BLOCK_HASH: 2,
  FROM_BLOCK_HEIGHT: 3
};

/**
 * @return {proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.FromBlockCase}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getFromBlockCase = function() {
  return /** @type {proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.FromBlockCase} */(jspb.Message.computeOneofCase(this, proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bloomFilter: (f = msg.getBloomFilter()) && proto.org.dash.platform.dapi.v0.BloomFilter.toObject(includeInstance, f),
    fromBlockHash: msg.getFromBlockHash_asB64(),
    fromBlockHeight: jspb.Message.getFieldWithDefault(msg, 3, 0),
    count: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sendTransactionHashes: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest;
  return proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.dash.platform.dapi.v0.BloomFilter;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.BloomFilter.deserializeBinaryFromReader);
      msg.setBloomFilter(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFromBlockHash(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFromBlockHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendTransactionHashes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBloomFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.dash.platform.dapi.v0.BloomFilter.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getSendTransactionHashes();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional BloomFilter bloom_filter = 1;
 * @return {?proto.org.dash.platform.dapi.v0.BloomFilter}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getBloomFilter = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.BloomFilter} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.BloomFilter, 1));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.BloomFilter|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
*/
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.setBloomFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.clearBloomFilter = function() {
  return this.setBloomFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.hasBloomFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes from_block_hash = 2;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getFromBlockHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes from_block_hash = 2;
 * This is a type-conversion wrapper around `getFromBlockHash()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getFromBlockHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFromBlockHash()));
};


/**
 * optional bytes from_block_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFromBlockHash()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getFromBlockHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFromBlockHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.setFromBlockHash = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.clearFromBlockHash = function() {
  return jspb.Message.setOneofField(this, 2, proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.hasFromBlockHash = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 from_block_height = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getFromBlockHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.setFromBlockHeight = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.clearFromBlockHeight = function() {
  return jspb.Message.setOneofField(this, 3, proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.hasFromBlockHeight = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 count = 4;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool send_transaction_hashes = 5;
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.getSendTransactionHashes = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsRequest.prototype.setSendTransactionHashes = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.BloomFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.BloomFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BloomFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    vData: msg.getVData_asB64(),
    nHashFuncs: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nTweak: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nFlags: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.BloomFilter}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.BloomFilter;
  return proto.org.dash.platform.dapi.v0.BloomFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.BloomFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.BloomFilter}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVData(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNHashFuncs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNTweak(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNFlags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.BloomFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.BloomFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.BloomFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getNHashFuncs();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getNTweak();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getNFlags();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional bytes v_data = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.getVData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes v_data = 1;
 * This is a type-conversion wrapper around `getVData()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.getVData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVData()));
};


/**
 * optional bytes v_data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVData()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.getVData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.BloomFilter} returns this
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.setVData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional uint32 n_hash_funcs = 2;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.getNHashFuncs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.BloomFilter} returns this
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.setNHashFuncs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 n_tweak = 3;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.getNTweak = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.BloomFilter} returns this
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.setNTweak = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 n_flags = 4;
 * @return {number}
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.getNFlags = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.dash.platform.dapi.v0.BloomFilter} returns this
 */
proto.org.dash.platform.dapi.v0.BloomFilter.prototype.setNFlags = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.ResponsesCase = {
  RESPONSES_NOT_SET: 0,
  RAW_TRANSACTIONS: 1,
  INSTANT_SEND_LOCK_MESSAGES: 2,
  RAW_MERKLE_BLOCK: 3
};

/**
 * @return {proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.ResponsesCase}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.getResponsesCase = function() {
  return /** @type {proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.ResponsesCase} */(jspb.Message.computeOneofCase(this, proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    rawTransactions: (f = msg.getRawTransactions()) && proto.org.dash.platform.dapi.v0.RawTransactions.toObject(includeInstance, f),
    instantSendLockMessages: (f = msg.getInstantSendLockMessages()) && proto.org.dash.platform.dapi.v0.InstantSendLockMessages.toObject(includeInstance, f),
    rawMerkleBlock: msg.getRawMerkleBlock_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse;
  return proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.dash.platform.dapi.v0.RawTransactions;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.RawTransactions.deserializeBinaryFromReader);
      msg.setRawTransactions(value);
      break;
    case 2:
      var value = new proto.org.dash.platform.dapi.v0.InstantSendLockMessages;
      reader.readMessage(value,proto.org.dash.platform.dapi.v0.InstantSendLockMessages.deserializeBinaryFromReader);
      msg.setInstantSendLockMessages(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setRawMerkleBlock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRawTransactions();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.dash.platform.dapi.v0.RawTransactions.serializeBinaryToWriter
    );
  }
  f = message.getInstantSendLockMessages();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.dash.platform.dapi.v0.InstantSendLockMessages.serializeBinaryToWriter
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional RawTransactions raw_transactions = 1;
 * @return {?proto.org.dash.platform.dapi.v0.RawTransactions}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.getRawTransactions = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.RawTransactions} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.RawTransactions, 1));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.RawTransactions|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} returns this
*/
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.setRawTransactions = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.clearRawTransactions = function() {
  return this.setRawTransactions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.hasRawTransactions = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional InstantSendLockMessages instant_send_lock_messages = 2;
 * @return {?proto.org.dash.platform.dapi.v0.InstantSendLockMessages}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.getInstantSendLockMessages = function() {
  return /** @type{?proto.org.dash.platform.dapi.v0.InstantSendLockMessages} */ (
    jspb.Message.getWrapperField(this, proto.org.dash.platform.dapi.v0.InstantSendLockMessages, 2));
};


/**
 * @param {?proto.org.dash.platform.dapi.v0.InstantSendLockMessages|undefined} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} returns this
*/
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.setInstantSendLockMessages = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.clearInstantSendLockMessages = function() {
  return this.setInstantSendLockMessages(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.hasInstantSendLockMessages = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bytes raw_merkle_block = 3;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.getRawMerkleBlock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes raw_merkle_block = 3;
 * This is a type-conversion wrapper around `getRawMerkleBlock()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.getRawMerkleBlock_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getRawMerkleBlock()));
};


/**
 * optional bytes raw_merkle_block = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRawMerkleBlock()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.getRawMerkleBlock_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getRawMerkleBlock()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.setRawMerkleBlock = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse} returns this
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.clearRawMerkleBlock = function() {
  return jspb.Message.setOneofField(this, 3, proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.dash.platform.dapi.v0.TransactionsWithProofsResponse.prototype.hasRawMerkleBlock = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.dash.platform.dapi.v0.RawTransactions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.RawTransactions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.RawTransactions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.RawTransactions.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionsList: msg.getTransactionsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.RawTransactions}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.RawTransactions;
  return proto.org.dash.platform.dapi.v0.RawTransactions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.RawTransactions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.RawTransactions}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addTransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.RawTransactions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.RawTransactions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.RawTransactions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes transactions = 1;
 * @return {!Array<string>}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.getTransactionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes transactions = 1;
 * This is a type-conversion wrapper around `getTransactionsList()`
 * @return {!Array<string>}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.getTransactionsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getTransactionsList()));
};


/**
 * repeated bytes transactions = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTransactionsList()`
 * @return {!Array<!Uint8Array>}
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.getTransactionsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getTransactionsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.org.dash.platform.dapi.v0.RawTransactions} returns this
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.setTransactionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.org.dash.platform.dapi.v0.RawTransactions} returns this
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.addTransactions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.dash.platform.dapi.v0.RawTransactions} returns this
 */
proto.org.dash.platform.dapi.v0.RawTransactions.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.InstantSendLockMessages.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.toObject = function(includeInstance, msg) {
  var f, obj = {
    messagesList: msg.getMessagesList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.InstantSendLockMessages;
  return proto.org.dash.platform.dapi.v0.InstantSendLockMessages.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.InstantSendLockMessages.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessagesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes messages = 1;
 * @return {!Array<string>}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.getMessagesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes messages = 1;
 * This is a type-conversion wrapper around `getMessagesList()`
 * @return {!Array<string>}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.getMessagesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getMessagesList()));
};


/**
 * repeated bytes messages = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessagesList()`
 * @return {!Array<!Uint8Array>}
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.getMessagesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getMessagesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages} returns this
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.setMessagesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages} returns this
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.addMessages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.dash.platform.dapi.v0.InstantSendLockMessages} returns this
 */
proto.org.dash.platform.dapi.v0.InstantSendLockMessages.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.MasternodeListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.MasternodeListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.MasternodeListRequest}
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.MasternodeListRequest;
  return proto.org.dash.platform.dapi.v0.MasternodeListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.MasternodeListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.MasternodeListRequest}
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.MasternodeListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.MasternodeListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.MasternodeListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.dash.platform.dapi.v0.MasternodeListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.dash.platform.dapi.v0.MasternodeListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    masternodeListDiff: msg.getMasternodeListDiff_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.dash.platform.dapi.v0.MasternodeListResponse}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.dash.platform.dapi.v0.MasternodeListResponse;
  return proto.org.dash.platform.dapi.v0.MasternodeListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.dash.platform.dapi.v0.MasternodeListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.dash.platform.dapi.v0.MasternodeListResponse}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMasternodeListDiff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.dash.platform.dapi.v0.MasternodeListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.dash.platform.dapi.v0.MasternodeListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasternodeListDiff_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes masternode_list_diff = 1;
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.prototype.getMasternodeListDiff = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes masternode_list_diff = 1;
 * This is a type-conversion wrapper around `getMasternodeListDiff()`
 * @return {string}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.prototype.getMasternodeListDiff_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMasternodeListDiff()));
};


/**
 * optional bytes masternode_list_diff = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMasternodeListDiff()`
 * @return {!Uint8Array}
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.prototype.getMasternodeListDiff_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMasternodeListDiff()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.org.dash.platform.dapi.v0.MasternodeListResponse} returns this
 */
proto.org.dash.platform.dapi.v0.MasternodeListResponse.prototype.setMasternodeListDiff = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


goog.object.extend(exports, proto.org.dash.platform.dapi.v0);
